

































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class StockRelocationItemView extends Vue {
  public items: Common.StockRelocationItem[] = new Array(0);
  public params: Common.StockRelocationItemQuery = new Common.StockRelocationItemQuery();
  public importQuery = new Common.ImportQuery('在庫移動明細','StockRelocationItem');
  public exportQuery = new Common.ExportQuery('在庫移動明細',this.params);
  public tenantSettings: Common.TenantSettings = null;
    public usedTypes = Common.UsedTypes;
  public sortOptions: any = [
    { value: 'State', text:'状態' },    
    { value: 'stockRelocationItemNo', text: '明細番号' },
    { value: 'stockRelocationNo', text: '在庫移動番号' },     
    { value: 'bookDate', text: '発生日' },    
    { value: 'warehouseIn', text: '入庫倉庫' },
    { value: 'warehouseOut', text: '出庫倉庫' },    
    { value: 'segment', text: '部門' },
    { value: 'commodity', text: '商品' },    
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },        
  ];
  @Prop() public stockRelocationNo:string;
  @Prop() public stockRelocationItemNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor; 

  public inputType:Common.InputTypes = Common.InputTypes.Delivery;
  public savingFlag: Common.StockRelocationItemStatus = Common.StockRelocationItemStatus.StockRelocationWaiting;
  public visibleTypes = Common.visibleTypes;  

  //一覧項目可変プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listGridConfig:Common.GridConfiguration =new Common.GridConfiguration([],14, 'grid');


  public created() {
    this.tenantSettings = this.$api.tenantSettings;

     // 明細の予備項目表示の可変対応
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('明細番号', 150),
      new Common.GridItemConfiguration('発生日', 150),
      new Common.GridItemConfiguration('出庫倉庫', 150),
      new Common.GridItemConfiguration('入庫倉庫', 150),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('移動数量', 150),

      new Common.GridItemConfiguration('在庫移動番号', 150),
      // new Common.GridItemConfiguration('行番号', 150),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('管理番号', 150),
    );
    this.listGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false,'出庫|'));
    this.listGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false,'入庫|'));
    this.listGridConfig.setGridItems(
      // new Common.GridItemConfiguration('ワークフロー', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );

    this.listCaptions =this.listGridConfig.gridCaptions;
    this.listWidths = this.listGridConfig.gridWidths;
    this.listSlots = this.listGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.stockRelocationNo){
      this.params.stockRelocationNo = this.stockRelocationNo;
      this.params.state = null;
    }
    if(this.stockRelocationItemNo) {
      this.params.stockRelocationItemNo = this.stockRelocationItemNo;
      this.params.state = null;
    }
    if(!this.stockRelocationItemNo && !this.stockRelocationNo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.StockRelocationItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_stockRelocationItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 在庫振替一覧へ遷移する
  public getStockRelocationLinkFormat(item : Common.StockTransferItem){
    return '/journal/StockRelocation?stockRelocationNo={0}';
  }


  
}
